import { TANSTACK_REFETCH_POLICY_SLOW } from 'config/RefetchPolicies'
import { useBaultById } from 'hooks/backend/baults'
import { useMemo } from 'react'
import { IslandApiResponse } from 'state/data/slice'

import { formatPercentage } from '../../../utils/numbers'

export function useBaultBonusInfo(island: IslandApiResponse | null) {
  const baultAddress = useMemo(() => {
    if (!island || !island.baults) return

    return island.baults[island.baults.length - 1]?.id
  }, [island])

  const { data: baultData, isLoading, error } = useBaultById(baultAddress, TANSTACK_REFETCH_POLICY_SLOW)

  const formattedApy = useMemo(() => {
    if (!baultData?.apy) return null

    const apyValue = parseFloat(baultData.apy)
    return `${formatPercentage(apyValue.toString())}`
  }, [baultData?.apy])

  return useMemo(() => {
    if (!baultAddress || error) return null

    return {
      show: true,
      icon: 'star',
      multipliers: isLoading ? ['Loading Bault APY...'] : [`Earn ${formattedApy} APY in Bault`],
      extraInfo: 'This pool is eligible for auto-compounding',
      baultAddress,
      isLoading,
      apy: parseFloat(baultData?.apy || '0'),
    }
  }, [baultAddress, error, isLoading, formattedApy, baultData?.apy])
}
